import React, { memo, useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { CallCenterBlock } from './CallCenterBlock';
import { CriteriaControls } from './CriteriaControls';
type Props = {
  className?: string;
  explanation: string;
  isSeller: boolean;
  title: string;
};
export const SearchNoResults = memo<Props>(
  ({ className, explanation, isSeller, title, ...rest }: Props) => {
    const [shouldNudge, setShouldNudge] = useState(false);
    return (
      <div
        {...rest}
        className={classnames('md:text-initial flex flex-col gap-15 p-20 text-center', className)}
      >
        <p className="text-16 font-bold md:text-20 lg:text-24">{title}</p>
        <div
          className={classnames({
            'font-bold text-orange': shouldNudge,
          })}
        >
          <p className="mb-10">{explanation}</p>
          <CriteriaControls setShouldNudge={setShouldNudge} />
        </div>
        {!isSeller && <CallCenterBlock />}
      </div>
    );
  },
);
